import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth'; // Import sendPasswordResetEmail
import { auth } from '../firebase';
import './AdminLogin.css';

function AdminLogin({ isAdminLoggedIn, setIsAdminLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [resetEmail, setResetEmail] = useState(''); // State for password recovery email
  const [showResetForm, setShowResetForm] = useState(false); // Toggle password recovery form
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem('isAdminLoggedIn', 'true'); // Save login state
      setIsAdminLoggedIn(true);
      alert('Admin logged in successfully!');
      navigate('/admin'); // Redirect to Admin Dashboard
    } catch (error) {
      alert('Login failed: ' + error.message);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      alert('Password reset email sent! Please check your inbox.');
      setShowResetForm(false); // Hide the reset form after success
    } catch (error) {
      alert('Failed to send password reset email: ' + error.message);
    }
  };

  return (
    <div className="admin-login-container">
      <h1 className='admin'>Admin Login</h1>
      {!showResetForm ? (
        <>
          <form onSubmit={handleLogin} className="admin-login-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Login</button>
          </form>
          <p>
            Forgot your password?{' '}
            <button
              type="button"
              className="password-reset-link"
              onClick={() => setShowResetForm(true)}
            >
              Reset Password
            </button>
          </p>
        </>
      ) : (
        <>
          <h2>Reset Password</h2>
          <form onSubmit={handlePasswordReset} className="password-reset-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              required
            />
            <button type="submit">Send Reset Email</button>
          </form>
          <button
            type="button"
            className="back-to-login"
            onClick={() => setShowResetForm(false)}
          >
            Back to Login
          </button>
        </>
      )}
    </div>
  );
}

export default AdminLogin;